<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0">
        <div class="m-b-10">Action</div>
        <v-radio-group v-model="property.type" hide-details class="m-l-15">
          <v-radio value="component" class="margin-radio">
            <template v-slot:label>
              <div class="d-flex width100 font-size-body">
                <div class="width70px">
                  Jump to
                </div>
                <div class="width100">
                  <v-select
                    class="shift-m-t"
                    v-model="property.component"
                    :items="itemFilter"
                    item-text="name"
                    item-value="id"
                    label="Component"
                    :disabled="property.type !== 'component'"
                    dense
                    hide-details
                  >
                    <template v-slot:selection="{ attrs, item }">
                      <div class="d-flex align-center">
                        <div class="width25px text-center m-r-5">
                          <v-icon small>{{ item.icon }}</v-icon>
                        </div>
                        {{ item.name }}
                      </div>
                    </template>
                    <template v-slot:item="{ index, item }">
                      <v-list-item-content class="list-icon">
                        <div class="d-flex">
                          <div class="width25px text-center m-r-5">
                            <v-icon small>{{ item.icon }}</v-icon>
                          </div>
                          {{ item.name }}
                        </div>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </div>
              </div>
            </template>
          </v-radio>
          <v-radio
            label="Exit"
            value="exit_page"
            :disabled="disabledExit"
            class="margin-radio"
          >
          </v-radio>
          <v-radio
            label="Break loop (if current page is inside a loop)"
            value="break_loop"
            :disabled="disabledExit"
            class="margin-radio"
          >
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object,
    items: Array,
    tabs: Array,
    currentTab: String
  },
  components: {
    NoteComponent
  },
  watch: {
    'property.component': {
      handler(value) {
        if (value) {
          const item = _.find(this.items, { id: value })
          if (item) this.node.name = `Jump to ${item.name}`
        }
      }
    },
    'property.type': {
      handler(value) {
        if (value === 'exit_page') this.node.name = 'Exit'
        else if (value === 'break_loop') this.node.name = 'Break loop'
      }
    }
  },
  data() {
    return {
      property: {},
      itemFilter: [],
      disabledExit: false
    }
  },
  created() {
    this.property = this.node.property

    if (!this.property.type) this.property.type = 'component'

    const itemFilter = _.filter(this.items, o => {
      return this.$nodeNoJump.indexOf(o.type) === -1
    })

    this.itemFilter = _.sortBy(itemFilter, [
      function(o) {
        return o.name.toLowerCase()
      }
    ])

    const tab = _.find(this.tabs, { name: this.currentTab })
    if (tab) {
      if (tab.name === 'Home' || tab.type === 'terminal')
        this.disabledExit = true
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.no-margin-top {
  margin-top: 0px !important;
}
.body-dialog {
  margin: 10px !important;
}
.width200px {
  width: 200px;
}
</style>
